export enum Type {
  House,
  Commercial_Space,
  Land,
  Other,
}
